export const COMMON_ROUTES = {
  LOGIN: '/',
};
